import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import './CodexCrew.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Importing the image at the top
import shaktijeetPhoto from '../assets/images/shaktijeet.png';
import tatshatSarangiPhoto from '../assets/images/IMG_20241011_120615215_HDR_AE - Tatshat Sarangi.jpg';
import surajPhoto from '../assets/images/Suraj.jpg';
import ashideepSahooPhoto from '../assets/images/PSX_20230516_141926 - 17-Ashadeep Sahoo.jpg';
import sekharPhoto from '../assets/images/Sekharcodex.jpg';
import seetalPandaPhoto from '../assets/images/SeetalPanda.jpg';
import ashisPhoto from '../assets/images/ashis.jpg';
// import aniketPhoto from '../assets/images/aniket.jpg';
import truptiDasPhoto from '../assets/images/6159B46E-ABB7-4130-8E68-42B381CB794C - Trupti Das.jpeg';
import tanyaPhoto from '../assets/images/tanya.jpg';
import shriyaPhoto from '../assets/images/shriya.jpg';
import snehaPhoto from '../assets/images/sneha.jpg';
import sonalidiPhoto from '../assets/images/sonalidi.jpg';

const members = [
  {
    name: 'Shaktijeet Sahoo',
    position: 'Chief Debugger',
    photo: shaktijeetPhoto
  },
  {
    name: 'Tatshat Sarangi',
    position: 'Code Commander',
    photo: tatshatSarangiPhoto
  },
  {
    name: 'Suraj Kumar Sahoo',
    position: 'Lead Coder',
    photo: surajPhoto
  },
  {
    name: 'Ashadeep Sahoo',
    position: 'Lead Coder',
    photo: ashideepSahooPhoto
  },
  {
    name: 'Sonali Monalisha Baral',
    position: 'Lead Coder',
    photo: sonalidiPhoto
  },
  // {
  //   name: 'Aniket Jena',
  //   position: 'Code Apprentices',
  //   photo: aniketPhoto
  // },
  {
    name: 'Ashis Kumar',
    position: 'Code Apprentices',
    photo: ashisPhoto
  },
  {
    name: 'Sekhar Parida',
    position: 'Code Apprentices',
    photo: sekharPhoto
  },
  {
    name: 'Seetal Panda',
    position: 'Code Apprentices',
    photo: seetalPandaPhoto
  },
  {
    name: 'Sriyasri Sahu ',
    position: 'Code Apprentices',
    photo: shriyaPhoto
  },
  {
    name: 'Trupti Das',
    position: 'Code Apprentices',
    photo: truptiDasPhoto
  },
  {
    name: 'Tanya Rout',
    position: 'Code Apprentices',
    photo: tanyaPhoto
  },
  {
    name: 'Sneha Padhi',
    position: 'Code Apprentices',
    photo: snehaPhoto
  }
  // Add other members if necessary...


  // other members...
];
const CodexCrew = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,  // Show 3 cards at a time
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    }, 3000); // Change slides every 3 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  return (
    <section id="codex-crew" className="codex-crew">
      <h2 className="crew-title">Codex Crew Members</h2>
      <Slider ref={sliderRef} {...settings}>
        {members.map((member, index) => (
          <div key={index} className="card">
            <img src={member.photo} alt={member.name} className="card-image" />
            <div className="card-info">
              <h3>{member.name}</h3>
              <p>{member.position}</p>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default CodexCrew;
